import StoreSmCardLoader from './StoreSmCardLoader';

const GroupLoader = ({ className }: any) => {
  return (
    <>
      <div className="group-row">
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
        <div>
          <StoreSmCardLoader className={className ? className : ''} />
        </div>
      </div>
    </>
  );
};

export default GroupLoader;
